import React from 'react'
import Footer from './Footer'
import BlogSection from './subSection/BlogSection'
import LandingSection from './subSection/LandingSection'

export default function HomePage({blog}) {
  return (
    <div>
      <div class="stars">
        <div class="twinkling">
          <div class="clouds">
          <LandingSection />
            <BlogSection blog={blog}/>
          <Footer/>
          </div>
        </div>
      </div>
      
    </div>
  )
}
